// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DnDFilterItemConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DnDFilterItemConfig
 */

import CONSTANTS from 'logic/data/Izenda.ReportDesignerConstants';
import { get, isNil } from 'lodash/fp';
import { resetStyleItem, hover } from 'share/utils/Izenda.FilterDnDUtils';

let position = { value: null };

export default {
  sourceOptions: {
    beginDrag(props: any) {
      props.onBeforeDrag && props.onBeforeDrag();
      return {
        itemType: CONSTANTS.GENNERAL.FILTER_ITEM,
        position: get('itemData.position', props),
        alias: get('itemData.alias', props),
        isParameter: get('itemData.isParameter', props),
        itemDataIndex: props.itemDataIndex,
        changePosition: true
      };
    },

    endDrag(props: any, monitor: any, component: any) {
      if (!monitor.didDrop()) {
        return;
      }

      component && resetStyleItem(component.props.store.reportFilters.filterFields);
      const dropResult = monitor.getDropResult();
      props = dropResult.props;
      monitor = dropResult.monitor;
      component = dropResult.component;

      if (!props || !monitor || !component) {
        return;
      }

      const item = monitor.getItem();

      if (isNil(item)) {
        return;
      }

      const dragItemIndex = item.itemDataIndex;
      const targetItemIndex = props.itemDataIndex;

      if (dragItemIndex === targetItemIndex) {
        return;
      }

      if (item.changePosition) {
        const nextIndex = item.itemDataIndex < position.value ? position.value - 1 : position.value;
        props.store.reportFilters.moveTo(item.itemDataIndex, nextIndex);
        return;
      }
    }
  },

  targetOptions: {
    drop(props: any, monitor: any, component: any) {
      if (monitor.didDrop()) {
        return;
      }

      if (props.viewMode === false && props.editMode) {
        return {
          props,
          monitor,
          component
        };
      }

      const item = monitor.getItem();

      if (isNil(item)) {
        return;
      }

      const dragItemIndex = item.itemDataIndex;
      const targetItemIndex = props.itemDataIndex;

      if (dragItemIndex === targetItemIndex) {
        return;
      }

      props.store.reportFilters.moveTo(dragItemIndex, targetItemIndex);
    },

    hover(props: any, monitor: any, component: any) {
      hover(props, monitor, component, position);
    }
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.DnDFilterItemConfig.js